import { useState } from 'react';
import CustomOrderForm from './CustomOrderForm';
import CustomOrdersList from './CustomOrdersList';
import './CustomOrders.css';
import Spinner from '../common/Spinner';

export default function CustomOrders({ canManageCustomOrders, permissionsLoading, userStore: userStoreId }) {
    const [activeTab, setActiveTab] = useState('create');

    if (permissionsLoading) {
        return (
            <div className="basicContainer">
                <Spinner />
            </div>
        );
    }

    if (!canManageCustomOrders) {
        return (
            <div className="basicContainer">
                <p>Acceso denegado.</p>
            </div>
        );
    }

    return (
        <div className="basicContainer custom-orders-container">
            <div className="custom-orders-wrapper">
            <header className="custom-orders-header">
                <div>
                    <p className="eyebrow">Pedidos Especiales</p>
                    <h1>Ordenes Especiales</h1>
                    <p className="subtitle">Crea y da seguimiento a pedidos especiales.</p>
                </div>
                <div className="custom-orders-tabs">
                    <button
                        className={`switchButton ${activeTab === 'create' ? 'active' : ''}`}
                        onClick={() => setActiveTab('create')}
                    >
                        Nueva Orden
                    </button>
                    <button
                        className={`switchButton ${activeTab === 'list' ? 'active' : ''}`}
                        onClick={() => setActiveTab('list')}
                    >
                        Tablero de Ordenes
                    </button>
                </div>
            </header>

            {activeTab === 'create' ? (
                <CustomOrderForm storeId={userStoreId} />
            ) : (
                <CustomOrdersList userStoreId={userStoreId} />
            )}
            </div>
        </div>
    );
}
